export const DISABLE_HOTKEYS_KEY = 'disableHotkeys'
